import { ADD_CART, GET_CART_REQUEST_SUCESSS, CLEAR_CART } from "../actions/types";

const initialState = {
  cart: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ADD_CART:
      return {
        cart: action.cart
      };
    case GET_CART_REQUEST_SUCESSS:
      return {
        cart: action.cart
      };
    case CLEAR_CART:
      return {
        ...state,
        cart: {}
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/cart.js